const STATUS_TRANSLATION_KEYS = {
  active: "Active",
  inactive: "Inactive",
  suspended: "Suspended",
  pending: "Pending",
  cancelled: "Cancelled",
  canceled: "Cancelled",
  expired: "Expired",
  paid: "Paid",
  failed: "Failed",
  refunded: "Refunded",
}

export const translateStatusLabel = (t, status) => {
  const normalized = String(status || "")
    .replace(/_/g, " ")
    .trim()
    .toLowerCase()

  if (!normalized || normalized === "—") {
    return "—"
  }

  const translationKey = STATUS_TRANSLATION_KEYS[normalized]
  return translationKey ? t(translationKey) : status
}

export const translateBillingCycle = (t, cycle) => {
  const normalized = String(cycle || "").toLowerCase()
  if (!normalized) return "—"
  if (normalized === "monthly") return t("Monthly")
  if (normalized === "annual" || normalized === "yearly") return t("Annual")
  return cycle
}

const PAYMENT_GATEWAY_TRANSLATION_KEYS = {
  free: "Free",
  manual: "Manual",
  tap: "TAP",
  checkout: "Checkout",
  tabs: "Tabs",
  paytabs: "PAYTABS",
  "gift-card": "Gift Card",
  giftcard: "Gift Card",
  "gift card": "Gift Card",
  none: "None",
}

export const translatePaymentGateway = (t, gateway) => {
  const raw = String(gateway || "").trim()
  if (!raw || raw === "—") {
    return "-"
  }

  const normalized = raw.toLowerCase().replace(/_/g, " ")
  const translationKey = PAYMENT_GATEWAY_TRANSLATION_KEYS[normalized]
  if (translationKey) {
    return t(translationKey)
  }

  const exact = t(raw)
  if (exact !== raw) return exact

  const titled = raw
    .toLowerCase()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
  const titledTranslated = t(titled)
  return titledTranslated !== titled ? titledTranslated : raw
}

const GATEWAY_STATUS_TRANSLATION_KEYS = {
  captured: "Captured",
  authorized: "Authorized",
  declined: "Declined",
  pending: "Pending",
  failed: "Failed",
  success: "Success",
  refunded: "Refunded",
  pending_token: "PENDING_TOKEN",
  "pending token": "PENDING_TOKEN",
  initiated: "Initiated",
  "card verified": "Card Verified",
}

export const translateGatewayStatus = (t, status) => {
  const raw = String(status || "").trim()
  if (!raw || raw === "—") {
    return "-"
  }

  const normalized = raw.toLowerCase().replace(/_/g, " ")
  const underscored = raw.toLowerCase()
  const translationKey =
    GATEWAY_STATUS_TRANSLATION_KEYS[normalized] ||
    GATEWAY_STATUS_TRANSLATION_KEYS[underscored]

  if (translationKey) {
    return t(translationKey)
  }

  const exact = t(raw)
  if (exact !== raw) return exact

  const titled = raw
    .toLowerCase()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
  const titledTranslated = t(titled)
  return titledTranslated !== titled ? titledTranslated : raw
}

export const localizedBilingualText = (value, language, fallback = "") => {
  if (!value) return fallback
  if (typeof value === "string") return value
  const uiLang = language === "sa" || language === "ar" ? "ar" : "en"
  return value?.[uiLang] || value?.en || value?.ar || fallback
}

export const translateGender = (t, gender) => {
  if (gender == null || gender === "") return "-"
  const normalized = String(gender).trim()
  const key =
    normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase()
  const translated = t(key)
  return translated || normalized
}
